import { submitFormData, showFormFeedback, showFeedbackInModal, showFeedbackInForm, validateCheckbox, submitBtnAnimation} from "./formFunctions";

export default class TrForm {
	constructor(form) {
		this.form = form;
		this.submitBtn = this.form.querySelector('button[type="submit"]');
		this.initialButtonText = this.submitBtn.innerHTML;
		// The form should either have a .form-feedback element, or the document should have a
		// .form-feedback-modal to display errors or success messages
		this.formFeedbackEl = document.querySelector('.form-feedback');
		this.formFeedbackModal = document.querySelector('.form-feedback-modal');
		this.invalidInputs = this.form.querySelectorAll('[aria-invalid="true"]');    

		this.events();
	}

	/**
	 * On the main form page, the "living" circle can be expanded to create
	 * a transition before redirecting after successful submission.
	 * @returns {Promise<void>}
	 */
	async animateLivingCircleBeforeRedirect() {
		const circle = this.form?.querySelector?.('.circle[data-field="living"]');
		if (!circle) return;

		circle.classList.add('grow');

		// The grow animation only applies when `.active` is present in CSS,
		// so ensure it's set (safe no-op if already active).
		circle.classList.add('active');

		await new Promise((resolve) => window.setTimeout(resolve, 1000));
	}

	events() {
		this.form.addEventListener('submit', (e) => this.handleFormSubmit(e));
	}

	revalidateInputs(e){
		const targetedInput = e.target;
		const targetValue = targetedInput.value;
		if(targetValue){
			const parentFormGroup = targetedInput.closest(".field");
			const invalidFeedback = targetedInput.nextElementSibling;
			targetedInput.classList.remove("is-invalid");
			targetedInput.removeAttribute("aria-invalid");
			targetedInput.removeAttribute("aria-describedby");
			parentFormGroup.classList.remove("is-invalid");
			invalidFeedback.remove();
		}
	}

	async handleFormSubmit(e) {
		e.preventDefault();

		this.submitBtn.disabled = true;
		this.submitBtn.classList.add('running');
		await new Promise((resolve) => window.setTimeout(resolve, 1000));

		// Remove any existing error messages
		const invalidInputs = this.form.querySelectorAll('.is-invalid');
		if (invalidInputs) {
			invalidInputs.forEach(input => input.classList.remove("is-invalid"));
		}
		const errorMessages = this.form.querySelectorAll('.invalid-feedback');
		if (errorMessages) {
			errorMessages.forEach(messageEl => messageEl.remove());
		}

		grecaptcha.enterprise.ready(async () => {
      await grecaptcha.enterprise.execute(params.grecaptcha_key, {action: 'submit'}).then((token) => {			
				const formData = new FormData(e.target);
				formData.append('submit', true);
				formData.append('recaptcha_token', token);
				submitFormData(formData)
					.then(async (successOrErrors) => {
						if (successOrErrors._debug) {
							console.log('[spotlight] form submit debug', successOrErrors._debug);
						}
						if(successOrErrors.success &&successOrErrors.redirect) {
							await this.animateLivingCircleBeforeRedirect();
							window.location.href = successOrErrors.redirect;
						} else {
							showFormFeedback(successOrErrors, this.form, this.formFeedbackEl, this.formFeedbackModal);
							if (successOrErrors.success) {
								// Form submitted - reset the form and clear any error messages/styles
								this.form.reset();
								this.submitBtn.disabled = false;
								this.submitBtn.classList.remove('running');
								const errorStyles = this.form.querySelectorAll('.is-invalid');
								if (errorStyles) {
									errorStyles.forEach(messageEl => messageEl.classList.remove('is-invalid'));
								}
							} else {             
								// Error submitting form - re-enable the submit button
								this.submitBtn.disabled = false;
								this.submitBtn.classList.remove('running');
								// Update the invalid inputs variable
								this.invalidInputs = this.form.querySelectorAll('[aria-invalid="true"]');
								this.invalidInputs.forEach(input => input.addEventListener("change", (e) => this.revalidateInputs(e)));   
							}
						}
					})
					// Server or network error
					.catch(err => {
						console.warn('Error: ', err);
						const error = {
							errors: {
								dummy: `Sorry, there has been a problem submitting the form.<br>
									Please try again later or email <a href="mailto:${params.main_email}">${params.main_email}</a>`
							}
						}
						showFormFeedback(error, this.form, this.formFeedbackEl, this.formFeedbackModal);
						this.submitBtn.disabled = false;
						this.submitBtn.classList.remove('running');
					});
			});
		});
	}
}
